(function(window, $){

    var $window = $(window);

        window.ps = {};

        window.ps.tap = function(element, handler) {

            var $element = $(element),
                    touchstart = ('ontouchstart' in document.documentElement ? 'touchstart' : 'mousedown'),
                    touchend = ('ontouchend' in document.documentElement ? 'touchend' : 'mouseup');

            $element.on(touchstart, function(){
                $element.data('scroll-position', $window.scrollTop());
            });

            $element.on(touchend, function(e){
                e.preventDefault();
                var upperLimit = $element.data('scroll-position') + Math.floor($element.height() / 2),
                        lowerLimit = $element.data('scroll-position') - Math.floor($element.height() / 2);
                if($window.scrollTop() < upperLimit && $window.scrollTop() > lowerLimit) {
                    handler(this);
                }
            });

        };

        // After DOM load
        $(document).ready(function(){

            // MENU
            var menuBreakpoint  = 979;
            var $hamburger      = $('#hamburger');
            var $menu           = $('#navigation');
            var $items          = $menu.find('.nav-item');
            var $activeItem     = $menu.find('.vinbanken');
            var $toggles        = $items.find('> a');
            var $submenus       = $items.find('.submenu');
            var $subitem        = $submenus.find('.container div > a');

            $menu.hide();

            if($subitem.hasClass('active')) {
                $activeItem.addClass('active');
                if($activeItem.hasClass('active')) {
                    $activeItem.children('a').addClass('active');
                }
            }
            else {
                $activeItem.removeClass('active');
            }

            

            window.ps.tap($hamburger, function(){
                if(window.innerWidth < menuBreakpoint){
                    if(!$hamburger.hasClass('close')) {
                        $menu.slideDown(250, 'linear', function(){
                            $hamburger.addClass('close');
                            window.ps.scrollPosition = $window.scrollTop();
                        });
                    }
                    else {
                        $menu.slideUp(250, 'linear', function(){
                            $hamburger.removeClass('close');
                            $window.scrollTop(window.ps.scrollPosition);
                        });
                    }
                }
            });

            window.ps.tap($toggles, function(element){
                if(window.innerWidth < menuBreakpoint) {

                    var $this       = $(element);
                    var $parent     = $this.parent();
                    var $submenu    = $this.next();

                    if (!$parent.hasClass('toggle')) {
                        $items.removeClass('toggle');
                        $parent.addClass('toggle');
                        $submenus.not($submenu).slideUp(250, 'linear');
                        $submenu.slideDown(250, 'linear');
                    }
                    else {
                        $submenu.slideUp(250, 'linear');
                        $parent.removeClass('toggle');
                    }
                }
            });

            // MENU END

            // FRONTPAGE SLIDER
            $('.recommended-slider').iosSlider({
                snapToChildren: true,
                desktopClickDrag: true,
                infiniteSlider: true,
                snapSlideCenter: true,
                autoSlide: true,
                navPrevSelector: $('.left-nav'),
                navNextSelector: $('.right-nav'),
                stageCSS: {
                    overflow: 'visible'
                }
            });
            // FRONTPAGE SLIDER END

            // PRODUCT IMAGES SLIDER
            var $slideshow = $('.mobile-product-images .images');
            var $slides = $slideshow.find('.slide');
            var $controls = $slideshow.find('.controls');

            if($slideshow.length && $slides.length && $controls.length){

                for(var i = 0; i < $slides.length; i++){
                    if(i == 0){
                        $controls.append('<span class="active"></span>');
                    } else {
                        $controls.append('<span></span>');
                    }
                }

                $slideshow.find('.iosslider').iosSlider({
                    desktopClickDrag: true,
                    snapToChildren: true,
                    navSlideSelector: $controls.find('span'),
                    onSlideChange: function(args){
                        var $spans = $controls.find('span');

                        $spans.removeClass('active');
                        $($spans.get(args.currentSlideNumber - 1)).addClass('active');
                    },
                    onSliderResize: function(args){
                        $slideshow.find('.iosslider').iosSlider('update');
                    }
                });

            }
            // PRODUCT IMAGES SLIDER END

            // PRODUCT IMAGE ZOOM
            var $productImage = $('.product-image .image');

            $('.image-thumb a').click(function() {
                if ($('.gallery').hasClass('current')) {
                    $('.gallery').removeClass('current');
                }
                $(this).addClass('current');

                var newImage = $(this).find('img').data('normal');
                var newZoom = $(this).find('img').data('zoom');

                $productImage.find('img').first().attr({ src: newImage }); 
                $productImage.find('img').last().attr({ src: newZoom }); 

                return false;
            });

            $productImage.zoom({url: $productImage.find('img').first().data('zoom')});
            // PRODUCT IMAGE ZOOM END

            // PRODUCT AMOUNT SELECT
            $(".increment").on("click", function() {

                var $button = $(this);
                var $input = $('.number input');
                var currentVal = $input.val();

              if ($button.hasClass('plus')) {
                  var newVal = parseFloat(currentVal) + 1;
                } 
                else {
                    if (currentVal > 0) {
                      var newVal = parseFloat(currentVal) - 1;
                    } 
                    else {
                      newVal = 0;
                    }
                }

              $button.parent().find("input").val(newVal);

            });
                

        });
        
}(window, $));